export const tooltipMessages = {
  appMode: {
    cropImageMode: '画像切り抜きモード',
    annotationMode: 'アノテーションモード'
  },
  navigation: {
    firstPage: '最初のページ',
    prevPage: '前のページ',
    nextPage: '次のページ',
    lastPage: '最後のページ'
  },
  toolbar: {
    undo: '最後の操作を取り消す',
    redo: '取り消した操作をやり直す',
    removeSelected: '選択中を削除',
    removeAll: 'すべて削除'
  }
};
